import React from 'react';
import { inject } from 'mobx-react';

import { localizable } from 'components/Localization';
import BaseStep from '../components/BaseStep';


@inject('app')
@localizable
class AwardSummary extends BaseStep {
  render() {
    const {
      store: { rejectedOfferDetails },
      t,
    } = this.props;

    return (
      <div>
        <h2>{t('Summary')}</h2>

        <h3>{t('Rejected customers offers')}</h3>
        <ol>
          {rejectedOfferDetails &&
            rejectedOfferDetails.map((i) => <li key={i.buyerId}>{this.renderBuyerName(i.item)}</li>)}
        </ol>

        <p>
          {t('If you click "Finish", you confirm the winner')}
          <br />
          {t('This action cannot be undone.')}
        </p>
      </div>
    );
  }
}

export default AwardSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/RejectSelected/Summary.jsx